export const ACCESS_KEY = "dcc_access_token";
export const REFRESH_KEY = "dcc_refresh_token";
export const USER_KEY = "dcc_user";

export function saveSession({ access_token, refresh_token, user }) {
  if (access_token) localStorage.setItem(ACCESS_KEY, access_token);
  if (refresh_token) localStorage.setItem(REFRESH_KEY, refresh_token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function primaryHomeForRoles(roles = []) {
  if (roles.includes("superadmin_dcc")) return "/app/superadmin";
  if (roles.includes("staff_dcc")) return "/app/staff";
  if (roles.includes("partner_admin")) return "/app/partner";
  if (roles.includes("instructor")) return "/app/instructor";
  if (roles.includes("reseller")) return "/app/affiliate";
  if (roles.includes("influencer")) return "/app/affiliate";
  if (roles.includes("alumno")) return "/app/alumno";
  return "/";
}
